import * as React from "react";
import { TouchableOpacity, View, TextInput, Dimensions } from "react-native";
import { Card, CardItem, Text, Button } from "native-base";
import { Row, Col, Grid } from "react-native-easy-grid";
import { formatNumber } from "accounting-js";

import Icon from "react-native-vector-icons/MaterialCommunityIcons";
import { currentLanguage } from "../../translations/CurrentLanguage";

let MoneyCurrency = require("money-currencies");
import translation from "../.././translations/translation";
import LocalizedStrings from "react-native-localization";
let strings = new LocalizedStrings(translation);
const SingleReceiptComponent = props => {
  strings.setLanguage(currentLanguage().companyLanguage);

  const Lines = props.receiptLines.map((line, index) => {
    const total = line.qty * line.price;
    return (
      <CardItem key={index} style={{ justifyContent: "space-between" }}>
        <View>
          <Text style={{ fontWeight: "bold", color: "#14213d" }}>
            {line.item_name}
          </Text>
          <Text style={{ color: "#aaa" }}>
            {line.qty} x{" "}
            {props.isCurrencyDisabled
              ? formatNumber(line.price.toFixed(2))
              : new MoneyCurrency(
                  props.currency ? props.currency : "PHP",
                ).moneyFormat(formatNumber(line.price.toFixed(2)))}
          </Text>
        </View>
        <View style={{ alignSelf: "flex-start" }}>
          <Text style={{ color: "#14213d" }}>
            {props.isCurrencyDisabled
              ? formatNumber(total.toFixed(2))
              : new MoneyCurrency(
                  props.currency ? props.currency : "PHP",
                ).moneyFormat(formatNumber(total.toFixed(2)))}
          </Text>
        </View>
      </CardItem>
    );
  });
  const Discount =
    props.discountName !== "" ? (
      <Text style={{ color: "#aaa" }}>
        {props.discountName} ({props.discountType})
      </Text>
    ) : (
      <Text style={{ color: "#aaa" }}>({strings.NoDiscount})</Text>
    );
  const Tax =
    props.receipt.taxesValue !== "0" ? (
      <Text style={{ color: "#aaa" }}>({props.receipt.taxesValue}%)</Text>
    ) : (
      <Text style={{ color: "#aaa" }}>({strings.NoTax})</Text>
    );
  const PrinterColorStatus =
    props.reprintStatus === "Online" ? "green" : "#aaa";

  return (
    <Card>
      <CardItem header style={{ borderBottomWidth: 1, borderColor: "gray" }}>
        <Grid>
          <Col
            style={{
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              width: Dimensions.get("window").width * 0.94 * 0.2,
            }}
          >
            <Row>
              <Text style={{ fontWeight: "bold", color: "#14213d" }}>
                <Icon name="receipt" size={21} color="#14213d" />{" "}
                {strings.ReceiptInformation}
              </Text>
            </Row>
            <Row>
              {props.status === "cancelled" ? (
                <Text style={{ color: "#aaa" }}>
                  <Icon name="circle" size={14} color="#aaa" />{" "}
                  {strings.Cancelled}
                </Text>
              ) : (
                <Button
                  style={{ marginTop: 5 }}
                  onPress={() => props.onChangeCancelStatus(true)}
                  disabled={props.cancelStatus}
                >
                  <Text>{strings.CancelReceipt}</Text>
                </Button>
              )}
            </Row>
          </Col>

          {props.status === "cancelled" ? (
            <Col
              style={{
                width: Dimensions.get("window").width * 0.94 * 0.53,
                borderRightWidth: 1,
                marginRight: 15,
              }}
            >
              <Row>
                <Text>{strings.Reason}: </Text>
              </Row>
              <Row
                style={{
                  flexDirection: "row",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              >
                <TextInput
                  editable={props.editStatus ? true : false}
                  style={{
                    marginLeft: 5,
                    borderBottomWidth: 1,
                    fontSize: 14,
                    width: Dimensions.get("window").width * 0.94 * 0.46,
                    color: "black",
                  }}
                  underlineColorAndroid="transparent"
                  value={props.reasonValue}
                  onChangeText={text => props.onChangeReason(text)}
                  multiline={true}
                />
                {props.editStatus ? (
                  <TouchableOpacity
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      marginLeft: 10,
                    }}
                    onPress={() => props.onCancel(props)}
                  >
                    <Icon name="content-save" size={26} color="#2563eb" />
                  </TouchableOpacity>
                ) : (
                  <TouchableOpacity
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      marginLeft: 10,
                    }}
                    onPress={() => props.onEditReason(true)}
                  >
                    <Icon name="pencil" size={24} color="#2563eb" />
                  </TouchableOpacity>
                )}
              </Row>
            </Col>
          ) : props.cancelStatus ? (
            <Col
              style={{
                width: Dimensions.get("window").width * 0.94 * 0.53,
                borderRightWidth: 1,
                marginRight: 15,
              }}
            >
              <Row>
                <Text>{strings.Reason}: </Text>
              </Row>
              <Row
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "flex-start",
                }}
              >
                <TextInput
                  editable={true}
                  style={{
                    marginLeft: 5,
                    borderBottomWidth: 1,
                    fontSize: 14,
                    width: Dimensions.get("window").width * 0.94 * 0.46,
                    color: "black",
                  }}
                  underlineColorAndroid="transparent"
                  value={props.reasonValue}
                  onChangeText={text => props.onChangeReason(text)}
                  multiline={true}
                />
                <TouchableOpacity
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    marginLeft: 10,
                  }}
                  onPress={() => props.onCancel(props)}
                >
                  <Icon name="content-save" size={26} color="#2563eb" />
                </TouchableOpacity>
              </Row>
            </Col>
          ) : (
            <Col
              style={{
                width: Dimensions.get("window").width * 0.94 * 0.53,
                borderRightWidth: 1,
                marginRight: 15,
              }}
            />
          )}
          <Col
            style={{
              width: Dimensions.get("window").width * 0.94 * 0.25,
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Button
              style={{ alignSelf: "center" }}
              onPress={() => props.onReprint(props)}
              disabled={props.reprintStatus !== "Online"}
            >
              <Text>{strings.Reprint}</Text>
            </Button>
            {/*<TouchableOpacity*/}
            {/*style={{ flexDirection: "row", alignItems: "center" }}*/}
            {/*onPress={() => props.onReprint(props)}*/}
            {/*>*/}
            <Icon name="printer" size={21} color={PrinterColorStatus} />
            <Text style={{ color: PrinterColorStatus }}>
              {props.reprintStatus}
            </Text>
            <Icon
              name="bluetooth-connect"
              style={{ color: "#2563eb", marginLeft: 16 }}
              size={24}
              onPress={() => props.connectDevice()}
            />
            {/*</TouchableOpacity>*/}
          </Col>
        </Grid>
      </CardItem>
      <CardItem>
        <Text style={{ fontWeight: "bold" }}>{strings.SoldTo}: </Text>
        <Text>{props.customer}</Text>
      </CardItem>
      <CardItem>
        <Text style={{ fontWeight: "bold" }}>{strings.ReceiptItems}</Text>
      </CardItem>
      {Lines}
      <CardItem style={{ justifyContent: "space-between" }}>
        <Text style={{ fontWeight: "bold" }}>{strings.Total}</Text>
        <Text>
          {props.isCurrencyDisabled
            ? formatNumber(props.total)
            : new MoneyCurrency(
                props.currency ? props.currency : "PHP",
              ).moneyFormat(formatNumber(props.total))}
        </Text>
      </CardItem>
      <CardItem style={{ justifyContent: "space-between" }}>
        <View>
          <Text style={{ fontWeight: "bold" }}>{strings.Tax}</Text>
          {Tax}
        </View>
        <Text>
          {props.isCurrencyDisabled
            ? formatNumber(props.receipt.taxesAmount)
            : new MoneyCurrency(
                props.currency ? props.currency : "PHP",
              ).moneyFormat(formatNumber(props.receipt.taxesAmount))}
        </Text>
      </CardItem>
      <CardItem style={{ justifyContent: "space-between" }}>
        <View>
          <Text style={{ fontWeight: "bold" }}>{strings.Discount}</Text>
          {Discount}
        </View>

        <Text>
          {props.isCurrencyDisabled
            ? formatNumber(props.discount)
            : new MoneyCurrency(
                props.currency ? props.currency : "PHP",
              ).moneyFormat(formatNumber(props.discount))}
        </Text>
      </CardItem>
      <CardItem style={{ justifyContent: "space-between" }}>
        <Text style={{ fontWeight: "bold" }}>{strings.AmountPaid}</Text>
        <Text>
          {props.isCurrencyDisabled
            ? formatNumber(props.amountPaid)
            : new MoneyCurrency(
                props.currency ? props.currency : "PHP",
              ).moneyFormat(formatNumber(props.amountPaid))}
        </Text>
      </CardItem>
      <CardItem style={{ justifyContent: "space-between" }}>
        <Text style={{ fontWeight: "bold" }}>{strings.AmountChange}</Text>
        <Text>
          {props.isCurrencyDisabled
            ? formatNumber(props.change)
            : new MoneyCurrency(
                props.currency ? props.currency : "PHP",
              ).moneyFormat(formatNumber(props.change))}
        </Text>
      </CardItem>
      <CardItem footer style={{ justifyContent: "space-between" }}>
        <Text style={{ color: "#aaa", fontWeight: "bold" }}>
          {strings.Transaction}
        </Text>
        <Text style={{ color: "#aaa" }}>{props.date}</Text>
      </CardItem>
    </Card>
  );
};

export default SingleReceiptComponent;
